export default {

    inviteRegisterLogoTitle1: 'You have been invited',
    inviteRegisterLogoTitle2: ' — win now!',
    inviteRegisterLogoTitle3: 'Your friend',
    inviteRegisterLogoTitle4: ' ({address}) ',
    inviteRegisterLogoTitle5: 'are already winning with Astral. Now it\'s your turn!',

    inviteRegisterPlaceholder1: 'Enter email',
    inviteRegisterPlaceholder2: 'Enter cell phone number',
    inviteRegisterPlaceholder3: 'Enter password（1-32 characters）',

    inviteRegisterSubmit1: 'CREATE A NEW ACCOUNT',
    inviteRegisterSeparateLine1: '------- Register by -------',

    inviteRegisterPlatformLicence1: 'Licensed platform and',
    inviteRegisterPlatformLicence2: ' 100% safe.',

    inviteRegisterPlatformBox1Title1: 'Welcome bonus',
    inviteRegisterPlatformBox1Title2: 'Both receive bonuses upon completing the registration',

    inviteRegisterPlatformBox2Title1: '0% of the fee',
    inviteRegisterPlatformBox2Title2: 'Trade anytime, anywhere, with no fees and more profits.',

    inviteRegisterPlatformBox3Title1: 'Reliable Crypto Help',
    inviteRegisterPlatformBox3Title2: 'From beginner to expert, we\'re here to help you every step of the way.',

    inviteRegisterPlatformBox4Title1: 'Trade with peace of mind',
    inviteRegisterPlatformBox4Title2: 'Regulated platform, with total security for your money.',

    inviteRegisterPrivacyPolicyTitle1: 'I agree with',
    inviteRegisterPrivacyPolicyTitle2: 'Privacy Policy',

    inviteRegisterVCodeDrawerTitleEmail: 'Verification code has been sent to your Email',
    inviteRegisterVCodeDrawerTitlePhone: 'Verification code has been sent to your Phone',

    inviteDownloadsTitle1: 'Download the APP',
    inviteDownloadsTitle2: 'Download Astral soon',
    inviteDownloadsTitle3: 'After the download is complete, go to Login',

    inviteDownloadsBtnLabel:'download',
    inviteDownloadsAppleLabel: 'Apple store',
    inviteDownloadsGooglePlayLabel: 'Google play',
    inviteDownloadsAndroidLabel: 'Android',

    depositSuccess: 'Pay Success !',
};
